<!-- MapTypeSelector.vue -->
<template>
  <div class="map-type-control">
    <label v-for="opt in options" :key="opt.value">
      <input type="radio" name="mapType" :value="opt.value" v-model="current" />
      <span>{{ opt.label }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: 'pale' | 'blank' | 'satellite' | 'hillshade'
}>()

const emit = defineEmits(['update:modelValue'])

const current = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const options = [
  { value: 'pale', label: '淡色地図' },
  { value: 'blank', label: '白地図' },
  { value: 'satellite', label: '衛星写真' },
  { value: 'hillshade', label: '起伏図' },
]
</script>

<style>
.map-type-control {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.map-type-control label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  cursor: pointer;
}

.map-type-control label + label {
  margin-top: 4px;
}
.map-type-control input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;

  width: 14px;
  height: 14px;
  border: 1px solid var(--gray02);
  border-radius: 50%;
  background: #fff;
  position: relative;
  cursor: pointer;
}

/* 選択中 */
.map-type-control input[type='radio']:checked {
  border-color: #1d7af3;
}

/* 中の● */
.map-type-control input[type='radio']:checked::after {
  content: '';
  position: absolute;
  inset: 1.1px;
  background: var(--blue02);
  border-radius: 50%;
}

@media (max-width: 767px) {
  .map-type-control {
    top: 3px; /* 少し上へ */
    right: -12px; /* 少し右へ */
    padding: 6px 8px; /* 全体をコンパクトに */
    border-radius: 6px;
  }

  .map-type-control label {
    font-size: 9px; /* 文字を小さく */
    gap: 4px;
  }

  .map-type-control label + label {
    margin-top: 2px;
  }

  .map-type-control input[type='radio'] {
    width: 12px; /* radioを小さく */
    height: 12px;
  }

  .map-type-control input[type='radio']:checked::after {
    inset: 2px; /* 中の●も縮小 */
  }
}
</style>
